module.exports = __webpack_public_path__ + "c1b4a7761762a0701c840b4e1fc4e53f.png";